import firebase from 'firebase'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyAoCf9qh7cHvcIujEcN2sqqwJxA0gsfUcE',
  authDomain: 'liberia-aims.firebaseapp.com',
  databaseURL: 'https://liberia-aims.firebaseio.com',
  projectId: 'liberia-aims',
  storageBucket: 'liberia-aims.appspot.com',
  messagingSenderId: '639476295598',
  appId: '1:639476295598:web:5c8ab0f89da2a50f414a3f'
}
// Initialize Firebase
export const app = firebase.initializeApp(firebaseConfig)
export const db = app.firestore()
export const auth = app.auth()
